module.exports = __webpack_public_path__ + "img/09d@2x.d235ab65.svg";